import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import messages from '../../locale/jsonMessages';
import { getOptionLabel, getOptionDescription, getBillingModeMessage } from '../../helpers/bookingOptionsPresentation';
import { OptionIcon } from './optionIcons';

// One line of the owner list: icon, label, description, billing mode (read only), price, switch, edit, delete.
function OptionRow({ option, currency, busy, adminMode, styles: s, onToggle, onEdit, onDelete, onAdminToggle }) {
  const { formatMessage, formatNumber } = useIntl();
  const [confirming, setConfirming] = useState(false);
  const label = getOptionLabel(option, formatMessage);
  const hasPrice = Number(option.price) > 0;
  const nameId = `bo-name-${option.slot}`;

  return (
    <li className={cx(s.row, option.adminDisabled && s.rowDisabled)}>
      <span className={s.rowIcon}><OptionIcon name={option.icon || (option.isFixed ? option.code : 'star')} /></span>
      <div className={s.rowText}>
        <strong id={nameId} className={s.rowLabel} title={label}>{label}</strong>
        <span className={s.rowDescription} title={getOptionDescription(option, formatMessage)}>{getOptionDescription(option, formatMessage)}</span>
        {option.adminDisabled && (
          <span className={s.adminBadge}>{formatMessage(messages.boDisabledByGozy)}</span>
        )}
      </div>
      <div className={s.rowPrice}>
        <span className={s.rowMode}>{formatMessage(getBillingModeMessage(option.billingMode))}</span>
        <span className={s.rowAmount}>
          {hasPrice ? `${formatNumber(option.price)} ${currency || ''}` : '-'}
        </span>
      </div>
      <div className={s.rowActions}>
        {/* The owner can never lift the admin switch: the toggle is locked while GOZY disabled the option. */}
        <label className={s.switch}>
          <input
            type="checkbox"
            checked={Boolean(option.isActive) && !option.adminDisabled}
            disabled={busy || option.adminDisabled}
            aria-labelledby={nameId}
            onChange={(event) => onToggle(option, event.target.checked)}
          />
          <span className={s.switchTrack} aria-hidden="true" />
        </label>
        <button type="button" className={s.iconButton} disabled={busy} onClick={() => onEdit(option)}
          aria-label={`${formatMessage(messages.boEdit)} - ${label}`} title={formatMessage(messages.boEdit)}>
          <span className="glyphicon glyphicon-pencil" aria-hidden="true" />
        </button>
        {!option.isFixed && (
          <button type="button" className={s.iconButton} disabled={busy} onClick={() => setConfirming(true)}
            aria-label={`${formatMessage(messages.delete)} - ${label}`} title={formatMessage(messages.delete)}>
            <span className="glyphicon glyphicon-trash" aria-hidden="true" />
          </button>
        )}
        {adminMode && option.id && (
          <button type="button" className={cx(s.textButton, s.adminButton)} disabled={busy}
            onClick={() => onAdminToggle(option)}>
            {formatMessage(option.adminDisabled ? messages.boReenable : messages.boDisableByGozy)}
          </button>
        )}
      </div>
      {confirming && (
        <div className={s.confirm} role="alertdialog" aria-label={formatMessage(messages.boDeleteConfirm)}>
          <span>{formatMessage(messages.boDeleteConfirm)}</span>
          <button type="button" className={s.dangerButton} disabled={busy}
            onClick={() => { setConfirming(false); onDelete(option); }}>
            {formatMessage(messages.delete)}
          </button>
          <button type="button" className={s.textButton} onClick={() => setConfirming(false)}>
            {formatMessage(messages.cancel)}
          </button>
        </div>
      )}
    </li>
  );
}

export default OptionRow;
